// 神策相关
export default {
  install() {},
  // install(Vue, options) {
  //   const sensors = window['sensorsDataAnalytic201505'];

  //   const server_url =
  //     process.env.NODE_ENV === 'production'
  //       ? '//sadataapi.msxf.com/sa?project=production'
  //       : '//sadataapi.msxf.com/sa?project=default';

  //   const sensorInit = () => {
  //     const ua = navigator.userAgent || navigator.vendor || window.opera || '';
  //     const uaVersion = ua.indexOf('APP_VERSION_');
  //     const currentVersion = Number(ua.substr(uaVersion, 20).replace(/\D/g, ''));
  //     const inAYHAPP = /msxfayh/gi.test(ua);
  //     // // 顺逸花4.0.12版本 不初始化神策
  //     if (!isNaN(currentVersion) && inAYHAPP && currentVersion >= 4001200) {
  //       return;
  //     }

  //     // 神策初始化
  //     sensors.init({
  //       app_js_bridge: true,
  //       send_type: 'beacon',
  //       server_url,
  //       // 是否在console开启上报上报日志
  //       // show_log: process.env.NODE_ENV !== 'production',
  //       heatmap: {
  //         //是否开启点击图，默认 default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭
  //         clickmap: 'not_collect',
  //         //是否开启触达注意力图，默认 default 表示开启，自动采集 $WebStay 事件，可以设置 'not_collect' 表示关闭
  //         scroll_notice_map: 'not_collect',
  //       },
  //       preset_properties: {
  //         title: true,
  //         url: true,
  //       },
  //     });

  //     // 拦截处理spm5层只有p_id的数据
  //     sensors.registerPropertyPlugin?.({
  //       isMatchedWithFilter(data: any) {
  //         // 如果只有p_id，没有其他id
  //         const { p_id, m_id, t_id, s_id, e_id } = data?.properties ?? {};
  //         return p_id && !(m_id || t_id || s_id || e_id);
  //       },
  //       properties(data: any) {
  //         // 删除p_id
  //         delete data.properties.p_id;
  //       },
  //     });

  //     if (window.SensorsDataWebJSSDKPlugin && window.UBSWebJSSDKPlugin) {
  //       window.SensorsDataWebJSSDKPlugin.PageSessionId = window.UBSWebJSSDKPlugin.PageSessionId;
  //     }
  //     // 神策埋点 SASpmReferrer
  //     if (window?.sensorsDataAnalytic201505 && process.env.APP_NAME === 'repay') {
  //       window.saSpmReferrer = window.sensorsDataAnalytic201505.use('SASpmReferrer');
  //     }
  //     sensors.use('RegisterPropertyPlugin');
  //     sensors.use('PageSessionId');

  //     window.Sensors = sensors;
  //   };

  //   if (!sensors) {
  //     setTimeout(sensorInit, 500);
  //   } else {
  //     sensorInit();
  //   }
  // },
};
